import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "thumb-bg" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "btn-wrap" }

import thumbnailContent from '@/assets/img/thumbnail-content.svg';
import '@/assets/img/thumbnail-bg.svg';

export default /*@__PURE__*/_defineComponent({
  __name: 'ThumbnailPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(thumbnailContent),
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/user/login",
        class: "btn-login"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Login")
        ])),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/user/signup",
        class: "btn-signup"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Sign up")
        ])),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/markup",
        class: "btn-markup"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Markup")
        ])),
        _: 1
      })
    ])
  ], 64))
}
}

})